import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { useTheme, getThemeClasses } from '../context/ThemeContext';

export default function BackToTop() {
  const { theme } = useTheme();
  const themeClasses = getThemeClasses(theme);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-4 right-4 ${themeClasses.primary} text-white p-2 rounded-full shadow-lg
                 hover:${themeClasses.primaryHover} transition-all duration-300 z-50
                 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}
      aria-label="Back to top"
    >
      <ArrowUp className="h-5 w-5" />
    </button>
  );
}